import { useReadLocalStorage } from 'usehooks-ts';
import { useMemo } from 'react';
import type { SessionValues } from '../types';
import { DEFAULT_SESSION_VALUES, SESSION_KEY } from '../constants';

export function useSessionValues() {
  const sessionData = useReadLocalStorage<SessionValues>(SESSION_KEY);
  const isExpired = useMemo(() => {
    if (!sessionData?.tokenExp) {
      return false;
    }
    try {
      return new Date(sessionData.tokenExp) < new Date();
    } catch {
      return false;
    }
  }, [sessionData?.tokenExp]);
  if (!sessionData) {
    return DEFAULT_SESSION_VALUES;
  }
  return {
    ...sessionData,
    isExpired,
  };
}

export function useSessionValue<K extends keyof SessionValues>(key: K) {
  const sessionData = useSessionValues();
  return sessionData[key];
}
